class Formatter {

    static boolean(value){
        if(value === 1)
            return 'Да';

        return 'Нет';
    }

    static dayShortName(value){
        const days = {
            0: 'Вс',
            1: 'Пн',
            2: 'Вт',
            3: 'Ср',
            4: 'Чт',
            5: 'Пт',
            6: 'Сб',
        }
        return days[value]
    }

    static MonthShortName(value){
        const mounth = {
            8: 'Сентябрь',
            9: 'Октябрь',
            10: 'Ноябрь',
            11: 'Декабрь',
            0: 'Январь',
            1: 'Февраль',
            2: 'Март',
            3: 'Апрель',
            4: 'Май',
            5: 'Июнь',
            6: 'Июль',
            7: 'Август',
        }
        return mounth[value]
    }

    static amountFormat(value, fraction = 0) {
        return new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: 'RUB',
            // These options are needed to round to whole numbers if that's what you want.
            //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            maximumFractionDigits: fraction,
        }).format(value);
    }

    static types() {
        return {
            feedback: 'Необработанные',
            kindergarten: 'Детский клуб',
            additional_class: 'Доп. занятия',
            individual_lesson: 'Индивидуальные',
            summer_camp: 'Летний лагерь',
            school: 'Школа'
        }
    }

    static dateWithOffset(date){
        let offset = date.getTimezoneOffset()
        return new Date(date.getTime() - (offset * 60 * 1000)).toISOString().split('T')[0]
    }

    static financeTypeString(type) {
        if(type === 'rub'){
            return 'Наличные'
        }
        if(type === 'card'){
            return 'Карта'
        }
        if(type === 'credit'){
            return 'Карта'
        }

        return false
    }

}

export default Formatter